import { useDispatch, useSelector } from "react-redux";
import { deletecart, minusqty, plusqty } from "../../redux/cart/actions";
import { minusproduct,plusproduct,deleteproduct } from "../../redux/product/actions";
function CartItemList({cart}){
  const product = useSelector((state) => state.product);  
  const dispatch = useDispatch();
  const {id, qty} = cart;
  const cartProduct = product.filter((product)=> id === product.id);
  const handleMinus = (id, pid)=> {
    if(cartProduct[0].qty >= 0){
      if(cartProduct[0].stock > cartProduct[0].qty + 1 ){
        dispatch(minusqty(id)); 
        dispatch(plusproduct(pid));
      }
    }
  }
  const handlePlus = (id, pid)=>{
    if(cartProduct[0].qty > 0){
      dispatch(plusqty(id));
      dispatch(minusproduct(pid));
    }
  }
  const handeDelete = (id,pid) => {
    dispatch(deletecart(id));
    dispatch(deleteproduct(pid))
  };
  return(
        <div className="cartCard">
            <div className="flex items-center col-span-6 space-x-6">
               {/* cart image  */}
              <img className="lws-cartImage" src={cartProduct[0].img} alt="product" />
               {/* cart item info  */}
              <div className="space-y-2">
                <h4 className="lws-cartName">{cartProduct[0].name}</h4>
                <p className="lws-cartCategory">{cartProduct[0].category}</p>
                <p>BDT <span className="lws-cartPrice">{cartProduct[0].price}</span></p>
              </div>
            </div>
            <div className="flex items-center justify-center col-span-4 mt-4 space-x-8 md:mt-0">
               {/* amount buttons  */}
              <div className="flex items-center space-x-4">
                <button className="lws-incrementQuantity" onClick={()=> handlePlus(id, cartProduct[0].id)}>
                  <i className="text-lg fa-solid fa-plus"></i>
                </button>
                <span className="lws-cartQuantity">{qty}</span>
                <button className="lws-decrementQuantity" onClick={()=> handleMinus(id, cartProduct[0].id)}>
                  <i className="text-lg fa-solid fa-minus"></i>
                </button>
              </div>
               {/* price  */}
              <p className="text-lg font-bold">BDT <span className="lws-calculatedPrice">{qty * cartProduct[0].price}</span></p>
            </div>
             {/* delete button  */}
            <div className="flex items-center justify-center col-span-2 mt-4 md:justify-end md:mt-0">
              <button className="lws-removeFromCart" onClick={()=> handeDelete(id, cartProduct[0].id)}>
                <i className="text-lg text-red-400 fa-solid fa-trash"></i>
              </button>
            </div>
          </div>
    )
}

export default CartItemList;